<script lang="ts" setup>
import type { ComputedOptions, ConcreteComponent, FunctionalComponent, MethodOptions } from 'vue';

const props = withDefaults(defineProps<{
    element?: 'div' | 'article' | 'a' | 'dialog' | ConcreteComponent<{}, any, any, ComputedOptions, MethodOptions> | FunctionalComponent<{}, any, any>;
  }>(),
{
  element: 'div',
});
const { element } = toRefs(props);
</script>

<template>
  <Component
    :is="element"
    class="m-card shadow-medmastery hover:shadow-medmastery-hard transition-all"
  >
    <slot />
  </Component>
</template>

<style lang="scss">
.m-card {
  display: block;
  position: relative;
  background-color: white;
  border-radius: 1rem;
  text-decoration: none;
  color: currentColor;
  transition: box-shadow 0.2s ease-out;

  &.direction-row {
    flex-direction: row;
  }

  &.direction-column {
    flex-direction: column;
  }
}
</style>